import { render, staticRenderFns } from "./‌goodsVoluntaryRefund.vue?vue&type=template&id=9f2e1bc6&scoped=true&"
import script from "./‌goodsVoluntaryRefund.vue?vue&type=script&lang=js&"
export * from "./‌goodsVoluntaryRefund.vue?vue&type=script&lang=js&"
import style0 from "./‌goodsVoluntaryRefund.vue?vue&type=style&index=0&id=9f2e1bc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2e1bc6",
  null
  
)

export default component.exports